const component = {

    /**
     * Init component
     * 
     * @returns {boolean|undefined}
     */
	init: () => {

        component.target = document.querySelectorAll('[data-event-tooltip]');

        if (!component.target)
            return false;

        component.target.forEach(tooltip => {
            component._initEvents(tooltip);
        });
	},

    /**
	 * Start to listen the click button
     * 
     * @param {object} tooltip A tooltip object.
     * @returns {undefined}
	 */
	_initEvents: (tooltip) => {

        if (window.screenMode == 'desktop-large' || window.screenMode == 'desktop') {

            let list_img = document.querySelectorAll('.event-image.with-event');

            list_img.forEach(item => {
                if (item.classList.contains(tooltip.dataset.eventTooltip)) {
                    item.addEventListener('mousemove', (e) => {
                        tooltip.classList.add('active');
                        tooltip.style.left = (e.clientX - 25) + 'px';
                        tooltip.style.top = (e.clientY + 30) + 'px';	
                    });
        
                    item.addEventListener('mouseleave', () => {
                        tooltip.classList.remove('active');
                    });
                }
            });
    
          }

	},
};

export default component;
